<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Welcome to FeedLetter
        <span class="is-size-6 has-text-grey">Step {{ currentStep }} of 2</span>
      </p>
    </header>
    <template v-if="currentStep == 1">
      <div class="modal-card-body">
        <div class="columns is-centered">
          <div class="column is-8 content">
            <p><span class="mr-1">👋</span> Hi friend,</p>

            <p>Ready to gather your first feedback?</p>

            <p>
              Let&#39;s start by telling me a bit more about your newsletter so
              that I can help better and promote it too.
            </p>

            <div class="field mt-5">
              <label class="label" for="referrer"
                >How did you hear about FeedLetter?</label
              >
              <div class="control">
                <input v-model="referrer" class="input" type="text" />
              </div>
            </div>

            <div class="field">
              <label class="label" for="newsletterName"
                >What's the name of your newsletter?</label
              >
              <div class="control">
                <input v-model="newsletterName" class="input" type="text" />
              </div>
            </div>
            <div class="field">
              <label class="label" for="newsletterUrl"
                >What's the link to your newsletter?</label
              >
              <div class="control">
                <input
                  v-model="newsletterUrl"
                  class="input"
                  type="url"
                  placeholder="https://"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="modal-card-foot is-justify-content-flex-end">
        
        <button class="button is-primary" @click="toStep2">Next</button>
      </footer>
    </template>
    <template v-if="currentStep == 2">
      <div class="modal-card-body">
        <div class="columns is-centered">
          <div class="column is-9 content">
            <div class="content">
              <p>
                Now it's time to create your first survey. Please select what
                you want to get feedback for:
              </p>
            </div>
            <div
              class="survey-select"
              v-bind:class="{ 'is-active': currentSurveyType == 1 }"
              @click="currentSurveyType = 1"
            >
              <div class="media">
                <div class="media-content">
                  <h2 class="title mb-2 is-5">Newsletter Survey</h2>
                  <p>
                    for regular newsletter emails. With time-based performance analytics. One per email.
                  </p>
                </div>
                <div class="media-right">
                  <b-tooltip
                    multilined
                    label="Create one per email and watch your readers' satisfaction develop over time with our powerful Time-based performance analytics."
                    type="is-light"
                  >
                    <b-icon
                      custom-class="has-text-grey-light"
                      size="is-small"
                      icon="info"
                    />
                  </b-tooltip>
                </div>
              </div>
            </div>

            <div
              class="survey-select"
              v-bind:class="{ 'is-active': currentSurveyType == 2 }"
              @click="currentSurveyType = 2"
            >
              <div class="media">
                <div class="media-content">
                  <h2 class="title mb-2 is-5">Onetime Poll</h2>
                  <p>for single questions in email sequences, ebooks, etc</p>
                </div>
                <div class="media-right">
                  <b-tooltip
                    multilined
                    label="Ask single questions or for feedback on single emails in email sequences or ebook chapters, etc. Pretty much anywhere where you can put a link."
                    type="is-light"
                  >
                    <b-icon
                      custom-class="has-text-grey-light"
                      size="is-small"
                      icon="info"
                    />
                  </b-tooltip>
                </div>
              </div>
            </div>
            <div
              class="survey-select"
              v-bind:class="{ 'is-active': currentSurveyType == 3 }"
              @click="currentSurveyType = 3"
            >
              <div class="media">
                <div class="media-content">
                  <h2 class="title mb-2 is-5">Web Rating</h2>
                  <p>for ratings on your web sites and web apps</p>
                </div>
                <div class="media-right">
                  <b-tooltip
                    multilined
                    label="Survey customer satisfaction with a simple 3-thumbs or 5 smiley emojis directly on your website or your web apps. The user stays on your site. Plus, get star ratings on your search rankings."
                    type="is-light"
                  >
                    <b-icon
                      custom-class="has-text-grey-light"
                      size="is-small"
                      icon="info"
                    />
                  </b-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <a class="is-flex mx-5 has-text-grey" @click="currentStep = 1">Back</a>
        <button
          class="button is-primary"
          :disabled="currentSurveyType == 0"
          @click="toFinish"
        >
          Create Now
        </button>
      </footer>
    </template>
  </div>
</template>

<script>
import atomic from "atomicjs";
import { mapState } from "vuex";
import {trackEvent}  from "../lib/flevents"
export default {
  name: "OnboardingDialog",
  props: {},
  data: function () {
    return {
      referrer: null,
      newsletterUrl: null,
      newsletterName: null,
      currentStep: 1,
      currentSurveyType: 0,
    };
  },
  mounted: function () {},
  computed: {
    ...mapState(["user", "account"]),
  },
  methods: {
    toFinish: function () {
      this.$parent.close();
      if (this.currentSurveyType == 0) {
        return;
      }

      var next = "FeedbackCreate";
      if (this.currentSurveyType == 2) {
        next = "OTFeedbackCreate";
      } else if (this.currentSurveyType == 3) {
        next = "WRFeedbackCreate";
      }

      trackEvent(this.$store.state.user.id, "onboarding-finished-"+ next)

      this.$router.push({
        name: next,
        query: { first: true },
      });
    },
    toStep2: async function () {
      if (!this.isEmptyOrSpaces(this.referrer)) {
        try {
          window._paq.push(["setCustomUrl", "/ref/" + this.referrer]);
          window._paq.push(["setDocumentTitle", this.referrer]);
          window._paq.push(["trackPageView"]);
        } catch (err) {}
      }
      if (!this.isEmptyOrSpaces(this.referrer) || !this.isEmptyOrSpaces(this.newsletterUrl) || !this.isEmptyOrSpaces(this.newsletterName)) {
        var step1Data = {
          referrer: this.isEmptyOrSpaces(this.referrer) ? null: this.referrer,
          newsletter_url: this.newsletterUrl,
          newsletter_name: this.newsletterName,
          id: this.$store.state.account.id
        };
        trackEvent(this.$store.state.user.id, "onboarding-step1-data")
        this.$store.dispatch('getAPIToken')
          .then((response) => {
            atomic(this.apiHost + "onboarding-details", {
              method: "POST",
              headers: {
                Authorization: "Bearer " + response,
                "Content-type": "application/json",
              },
              data: step1Data,
            })
              .then(function (response) {})
              .catch(function (error) {
                console.log(error.status); // xhr.status
                console.log(error.statusText); // xhr.statusText
              });
          });
      } else {
        trackEvent(this.$store.state.user.id, "onboarding-step1-nodata")
      }
      
      this.currentStep = 2;
    },
  },
};
</script>

<style scoped lang="scss">
.modal-card-body {
  height: 440px !important;
}

.survey-select {
  border: 1px solid hsl(0, 0%, 96%);
  margin-bottom: 0.8rem;
  background-color: white;
  border-radius: 8px;
  color: #4a4a4a;
  display: block;
  padding: 1rem;
  cursor: pointer;
}

.survey-select.is-active {
  border: 1px solid #4bbf73;
}

.has-text-grey svg {
  stroke: hsl(0, 0%, 48%);
}
</style>